/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { useTranslation, Trans } from "react-i18next";
import { useTour } from "@reactour/tour";

/* 🧩 COMPONENTS */
import { SelectCitie, CustomLoading, Button } from "../../Components";
import ModalDesign from "../../Components/ModalDesign";
import { ModalMap, ModalLine, ListEquipamentos, EquipamentCard } from "./Components/index.js";

/* 🔗 SERVICE */
import { MapRequests } from "../../Services/mapServices/requests.ts";
import { MapService } from "../../Services/mapServices";

/* 🧠 REDUX */
import { store } from "../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { ChangeMapShowCaption, changeModal, ChangeUserInfo } from "../../Redux/Actions";

/* 📁 ASSETS*/
import { Advertencia, Critico, Manutencao, PerdaComunicacao, RelogioIcon, Ajuda, Augen_white, Bio,
    ETA, Poco, Reservatorio, Pressure, Level, Vazao, GeneralIcon } from "../../Assets/icons";
import { ControlIcon, DashIcon } from "../../Assets/icons/MenuIcons/index.js";

/* 🎨 STYLES */
import "mapbox-gl/dist/mapbox-gl.css";
import { ContainerMap, ButtonContainer, Container, AccessButton, ButtonsContainer, CaptionGroup, ButtonIcon,
    LastUpdateText, LastUpdateIcon, CaptionContainer, CaptionContent, CaptionButton, CaptionImg, CaptionItem, CaptionImage, 
    LastUpdateEquipament, NewDesignText, NewDesignTitle, WaveLeft, WaveRight } from "./styles";
import { HelpIcon } from "../styles.js"

/* 🔧 UTILS */
import { getDataString } from "../../util/Months.js";
import { mapSteps } from "../../util/tour/map.js";
import { homeSteps } from "../../util/tour/home.js";

const Home = () => {
    const { t } = useTranslation();
    const { setIsOpen, isOpen, currentStep, setSteps } = useTour();
    const user = useSelector(state => state.userReducer);

    document.title = t("map.document-title");

    const navigate = useNavigate();
    const initialStep = homeSteps(t);
    const steps = mapSteps(t);

    const mapContainerRef = useRef(null);
    const mapServices = useRef(null);
    const mapRequests = useRef(new MapRequests());

    const checkedTutorial = useSelector(state => state.mapReducer.checkedTutorial);
    const showCaption = useSelector(state => state.mapReducer.showCaption);
    const equipamento = useSelector(state => state.mapReducer.equipamento);
    const dados = useSelector(state => state.mapReducer.dados);
    const isLoadingModal = useSelector(state => state.mapReducer.isLoadingModal);
    const status = useSelector(state => state.mapReducer.state);
    const Buttons = useSelector(state => state.mapReducer.Buttons);
    const EquipamentDataList = useSelector(state => state.mapReducer.EquipamentDataList);
    
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentCitie, setCurrentCitie] = useState('');
    const [TimeReset, setTimeReset] = useState(getDataString(new Date().getHours()) + ' h ' + getDataString(new Date().getMinutes())+' min');
    
    useEffect(() => {
        if(!user?.user?.checkedWarning){
            store.dispatch(changeModal('newDesignBio'));
        }

        const intervalId = setInterval(() => {
            const now = new Date();
            setTimeReset(`${getDataString(now.getHours())} h ${getDataString(now.getMinutes())} min`);
            mapServices.current.restart();
        }, 150000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    useEffect(() => {
        async function StartAndGetCities(){
            setLoading(true);
            await mapServices.current.start();
            setLoading(false);
            try{
                let tempCities = await mapRequests.current.RequestCities();
                
                tempCities.authorized_cities.unshift({
                    name: t("select.city"),
                    value: ''
                })
                setCities(tempCities.authorized_cities);
                // verifica se há cidade salva no localstorage 
                // se não verifica se há mais de uma cidade autorizada e manda para o estado da primeira cidade 
                // se não manda para primeira cidade
                try {
                    if(localStorage.getItem('currentMapCity') && JSON.parse(localStorage.getItem('currentMapCity'))){
                        try {
                            mapServices.current.changeMapCenter(JSON.parse(localStorage.getItem('currentMapCity')).coordinates);
                            setCurrentCitie(JSON.parse(localStorage.getItem('currentMapCity')).code);
                        } catch (error) {
                            console.log(error);
                        }
                    }else if(tempCities.authorized_cities.length > 2){
                        mapServices.current.changeMapCenter([tempCities.authorized_cities[1].state.coordinates.longitude, tempCities.authorized_cities[1].state.coordinates.latitude], 6.8);
                        setCurrentCitie('');
                    }else{
                        setCurrentCitie(tempCities.authorized_cities[1].code_ibge)
                        mapServices.current.changeMapCenter([tempCities.authorized_cities[1].coordinates.longitude, tempCities.authorized_cities[1].coordinates.latitude]);
                    }
                } catch (error) {
                    console.log(error)
                }
            } catch (error) {
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
            }
        }

        mapServices.current = new MapService(mapContainerRef.current, navigate);

        StartAndGetCities();      
    }, [navigate, t]);

    useEffect(() => {
        let timeoutId = 0;
        if (!checkedTutorial) {
            setSteps(initialStep);
            timeoutId = setTimeout(() => setIsOpen(true), 1000);
        }
       
        return () => {
            setIsOpen(false);       
            setSteps([]); 
            clearTimeout(timeoutId);        
        };
    }, [checkedTutorial]);

    useEffect(() => {
        const noThanks = document.querySelector('#no-thanks'); 

        const handler = async() => await mapServices.current.handleRequestTourFlag();

        if (isOpen && noThanks && handler) {
            noThanks.addEventListener('click', handler);
        }
        return () => {
            if (noThanks && handler) {
                noThanks.removeEventListener('click', handler);
            }
        };
    }, [isOpen]);

    const changeCity = (value) => {
        let newCity = cities.find(city => parseInt(city.code_ibge) === parseInt(value));
        if(newCity){
            mapServices.current.changeMapCenter([newCity.coordinates.longitude, newCity.coordinates.latitude]);
            localStorage.setItem('currentMapCity', JSON.stringify({
                coordinates: [newCity.coordinates.longitude, newCity.coordinates.latitude],
                code: newCity.code_ibge
            }));
            setCurrentCitie(newCity.code_ibge);
        }
    }

    const handleTour = (flag) => {
        const equipment = mapServices.current.startTour(flag);
        if (!equipment) return;
    
        setSteps(steps);

        const duration = mapServices.current.changeMapCenter(
            equipment.geometry.coordinates,
            19.5
        );

        const marker = document.createElement('div');
        marker.id = 'equipment-marker';
    
        marker.addEventListener('click', (e) => {
            const isSynthetic = !e.isTrusted;
            if (isSynthetic && !isOpen) {
                mapServices.current.openTourPopup(
                    equipment.properties.id,
                    equipment.geometry.coordinates,
                    equipment.properties
                );
            }
        });
    
        mapContainerRef.current?.appendChild(marker);
  
        setTimeout(() => setIsOpen(true), duration);
    };

    const handleDateTime = (value) => {
        if (!value) return ""; 

        const match = value.match(/^(\d{1,2})\/(\d{1,2}) - (\d{1,2}):(\d{1,2})$/);
        if (!match) return "";

        const [, day, month, hours, minutes] = match;

        const dateObj = new Date();
        dateObj.setMonth(Number(month) - 1);
        dateObj.setDate(Number(day));
        dateObj.setHours(Number(hours));
        dateObj.setMinutes(Number(minutes));
        dateObj.setSeconds(0);
        dateObj.setMilliseconds(0);

        return t("date.day-month-hour", { date: dateObj, format: "dayMonthAndHour" });
    }

    async function setNewDesignTag(){
        try {
            await mapRequests.current.setNewDesignTag();
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <Container>
                {loading && <CustomLoading width={'200px'} height={'200px'}/>}
                <ContainerMap ref={mapContainerRef}>
                </ContainerMap>
                <ButtonContainer>
                    {cities.length > 0 && 
                        <SelectCitie disabled={loading} id={"select-city"} options={cities} value={currentCitie} onChange={(e) => changeCity(e.target.value)}/>
                    }
                </ButtonContainer>
                <div className="container">
                    <LastUpdateText> 
                        <LastUpdateIcon src={RelogioIcon}/>
                        {TimeReset}
                    </LastUpdateText>
                    <Button id={"tour-button"} color={"green"} disabled={isOpen || loading} onClick={() => handleTour()} icon={<HelpIcon src={Ajuda} className={"icon"} />} padding={"8px 10px"} radius={"3px"} width={"44px"}/>
                </div>
            </Container>

            <CaptionContainer>
                <CaptionButton id="caption-button" $showCaption={showCaption} onClick={() => store.dispatch(ChangeMapShowCaption(!showCaption))} disabled={isOpen && currentStep === 1}>
                    {t("map.caption.label")}
                </CaptionButton>
                    <CaptionContent id="caption" $showCaption={showCaption}>
                        <CaptionItem>
                            <strong>
                                {t("map.caption.equipment.label")}
                            </strong>
                            <CaptionGroup>
                                <CaptionImage src={Vazao} $width={'30px'} $height={'16px'}/>
                                {t("map.caption.equipment.flow")}
                            </CaptionGroup>
                            <CaptionGroup>
                                <CaptionImage src={Level} $width={'17px'} $height={'30px'}/>
                                {t("map.caption.equipment.level")}
                            </CaptionGroup>
                            <CaptionGroup>
                                <CaptionImage src={Pressure} $width={'31px'} $height={'23px'}/>
                                {t("map.caption.equipment.pressure")}
                            </CaptionGroup>
                            <CaptionGroup>
                                <CaptionImage src={Reservatorio} $width={'21px'} $height={'25px'}/>
                                {t("map.caption.equipment.reservoir")}
                            </CaptionGroup>
                            <CaptionGroup>
                                <CaptionImage src={GeneralIcon} $width={'30px'} $height={'30px'}/>
                                {t("map.caption.equipment.analyzer")}
                            </CaptionGroup>
                            <CaptionGroup>
                                <CaptionImage src={Poco} $width={'30px'} $height={'30px'}/>
                                {t("map.caption.equipment.well")}
                            </CaptionGroup>
                            <CaptionGroup>
                                <CaptionImage src={ETA} $width={'65px'} $height={'30px'}/>
                                {t("map.caption.equipment.eta")}
                            </CaptionGroup>
                        </CaptionItem>
                        <CaptionItem>
                            <strong>
                                {t("map.caption.alarms.label")}
                            </strong>
                            <CaptionGroup>
                                <CaptionImg src={Critico}/>
                                {t("map.caption.alarms.critical")}
                            </CaptionGroup>
                            <CaptionGroup>
                                <CaptionImg src={Advertencia}/>
                                {t("map.caption.alarms.warning")}
                            </CaptionGroup>
                            <CaptionGroup>
                                <CaptionImg src={PerdaComunicacao}/>
                                {t("map.caption.alarms.communication-loss")}
                            </CaptionGroup>
                            <CaptionGroup>
                                <CaptionImg src={Manutencao}/>
                                {t("map.caption.alarms.maintenance")}
                            </CaptionGroup>
                        </CaptionItem>
                    </CaptionContent>
            </CaptionContainer>

            <ListEquipamentos id={"pinned-equipments"}>
                {EquipamentDataList.map((equipamento, index) => (
                    <EquipamentCard key={index} id={[equipamento.id, "unpin-button"]} dados={equipamento.data} type={equipamento.type} equipamento={equipamento.name} status={equipamento.status}/>
                ))}
            </ListEquipamentos>
            <ModalMap id={"map-modal"} title={equipamento.nome} name={'mapmodal'} width={'50%'} height={'fit-content'} 
                $background={status === 4 ? '#E1800E' : status === 3 ? '#6600CC' : status === 2 ? '#FF3939': status === 1 ? '#EABC1A' : status === 0 ? '#33CC99' : '#F6F6F6'}>
                {isLoadingModal ?
                    <CustomLoading width={'150px'} height={'150px'}/>
                :
                    <>
                        {dados?.data?.map((dado, index) => (
                            <ModalLine key={index} dado={dado} showvalue2={dados?.data.some(obj => obj.hasOwnProperty('value2'))}/>
                        ))}
                        {dados?.time && <LastUpdateEquipament> <LastUpdateIcon src={RelogioIcon}/>{handleDateTime(dados.time)}</LastUpdateEquipament>}
                    </>
                }
                <ButtonsContainer>
                    {Buttons.dash &&
                        <AccessButton onClick={()=> navigate(`/dashboard/${equipamento.id}`)} disabled={isOpen && currentStep === 6}>
                            <ButtonIcon src={DashIcon} fill={'#006560'}></ButtonIcon>
                            {t("buttons.dashboard")}
                        </AccessButton>}
                    {Buttons.control &&
                        <AccessButton onClick={()=> navigate(`/controle/${equipamento.id}`)} disabled={isOpen && currentStep === 6}>
                            <ButtonIcon src={ControlIcon} fill={'#006560'}></ButtonIcon>
                            {t("buttons.control")}
                        </AccessButton>}
                </ButtonsContainer>
            </ModalMap>

            <ModalDesign name={'newDesignBio'} active={true} width={'50%'} height={'60%'}>
                <WaveLeft/>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px', marginBottom: '25px', paddingInline: '40px'}}>

                    <div style={{display: 'flex', justifyContent: 'center', gap: '10px', flexDirection: 'row', flexWrap: 'wrap'}}>
                        <img style={{width: '150px', height: 'auto'}} src={Augen_white} alt="Augen Logo"/>
                        <img style={{width: '150px', height: 'auto'}} src={Bio} alt="Bio Logo"/>
                    </div>

                    <NewDesignTitle style={{textAlign: 'center', color: '#fff'}}>{t('new-design-bio.title')}</NewDesignTitle>

                    <div style={{display: 'flex', flexDirection: 'column', gap: '15px', paddingInline: '25px'}}>
                        <NewDesignText style={{textAlign: 'center', color: '#fff'}}>{t('new-design-bio.text1')}</NewDesignText>
                        <NewDesignText style={{textAlign: 'center', color: '#fff'}}>
                            <Trans i18nKey='new-design-bio.text2' components={{br: <br />, strong: <strong /> }} />
                        </NewDesignText>
                        <NewDesignText style={{textAlign: 'center', color: '#fff'}}>{t('new-design-bio.text3')}</NewDesignText>
                    </div>

                    <Button text={t("buttons.dont-show")} width={'250px'} onClick={() => {
                        store.dispatch(changeModal(null));
                        store.dispatch(ChangeUserInfo({...user, user: {...user.user, checkedWarning: true}}));
                        setNewDesignTag();
                    }}/>
                </div>

                <WaveRight/>
            </ModalDesign>
        </>
    );
}

export default Home;
